import React from 'react';
import useFilterModalContext from '../../useFilterModalContext';
import useSearchParams from '../../../../useSearchParams';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';

const ProspectScore = () => {
  const {setFilterType} = useFilterModalContext();
  const {query, setQuery} = useSearchParams();

  const hasScoreRange = query?.prospectScore?.from || query?.prospectScore?.to;
  const hasRankFilter = query?.totalScoreRanks?.length > 0;

  if (!hasScoreRange && !hasRankFilter) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">顧客スコア</h4>
        <button
          onClick={() => setFilterType('prospectScore')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-foreground-lighter cursor-pointer"
        >
          <ArrowRightIcon className="w-3 h-3 text-foreground-light" />
        </button>
        <button
          onClick={() =>
            setQuery({
              ...query,
              prospectScore: {},
              totalScoreRanks: [],
            })
          }
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-foreground-lighter cursor-pointer"
        >
          <XMarkIcon className="w-3 h-3 text-foreground-light" />
        </button>
      </div>
      <div className="flex flex-col gap-2">
        {hasRankFilter && (
          <div>
            <span className="text-sm text-foreground-light mr-2">ランク:</span>
            {query.totalScoreRanks.map((rank: string) => (
              <span
                key={rank}
                className="text-sm inline-block border border-border rounded-sm bg-background px-2 mr-1"
              >
                {rank.toUpperCase()}
              </span>
            ))}
          </div>
        )}
        {hasScoreRange && (
          <div>
            <span className="text-sm text-foreground-light mr-2">スコア:</span>
            {query.prospectScore.from && (
              <span className="text-sm inline-block border border-border rounded-sm bg-background px-2">
                {query.prospectScore.from}
              </span>
            )}
            <span className="text-foreground-light px-2">~</span>
            {query.prospectScore.to && (
              <span className="text-sm inline-block border border-border rounded-sm bg-background px-2">
                {query.prospectScore.to}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProspectScore;
